import React, { Component } from "react";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import { View_Take_Money } from "../../../actions_agent/Invoice_action";
import PrintViewTakemoneyEn from "./PrintViewTakemoneyEn";
import PrintViewTakemoney from "./PrintViewTakemoney";
class RentPrint extends Component {
 componentDidMount() {
  this.props.View_Take_Money(
   this.props.match.params.id,
   this.props.match.params.index
  );
 }
 render() {
  const { lang, take_money_view } = this.props;
  return (
   <>
    {lang === "krd" ? (
     <PrintViewTakemoney take_money_view={take_money_view} />
    ) : lang === "arb" ? (
     <PrintViewTakemoney take_money_view={take_money_view} />
    ) : (
     <PrintViewTakemoneyEn take_money_view={take_money_view} />
    )}
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  take_money_view: state.Invoice_Reducer.take_money_view,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
  change_Lang: (key) => dispatch(change_Lang(key)),
  View_Take_Money: (id, index) => dispatch(View_Take_Money(id, index)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrint);
